import { Shimmer, ShimmerLoader } from "../../../../components/common/shimmer";

/**
 * Skeleton placeholder for the payment step. Mirrors the final two-column
 * layout (payment-method + card-details + billing on the left, order
 * summary on the right) so swapping in the real form doesn't reflow.
 *
 * The visible message under the skeleton is rendered by the wrapping
 * <ShimmerLoader> for screen-reader announcement; the bars themselves are
 * decorative.
 */
export function PaymentViewSkeleton() {
  return (
    <ShimmerLoader message="Preparing your secure checkout…">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="flex flex-col gap-6 lg:col-span-2">
          <SkeletonCard>
            <Shimmer className="h-5 w-40" />
            <div className="grid grid-cols-2 gap-3">
              <Shimmer className="h-16 w-full" />
              <Shimmer className="h-16 w-full" />
              <Shimmer className="h-16 w-full" />
              <Shimmer className="h-16 w-full" />
            </div>
          </SkeletonCard>

          <SkeletonCard>
            <Shimmer className="h-5 w-36" />
            <Shimmer className="h-12 w-full" />
            <div className="grid grid-cols-2 gap-3">
              <Shimmer className="h-12 w-full" />
              <Shimmer className="h-12 w-full" />
            </div>
          </SkeletonCard>

          <SkeletonCard>
            <div className="flex items-center justify-between">
              <Shimmer className="h-5 w-32" />
              <Shimmer className="h-5 w-44" />
            </div>
          </SkeletonCard>

          <Shimmer className="h-12 w-full rounded-full" />
        </div>

        <div className="lg:col-span-1">
          <SkeletonCard>
            <Shimmer className="h-5 w-32" />
            <div className="flex flex-col gap-2">
              <Shimmer className="h-4 w-full" />
              <Shimmer className="h-4 w-5/6" />
              <Shimmer className="h-4 w-4/6" />
            </div>
            <div className="border-t border-borderDefault" />
            <div className="flex flex-col gap-2">
              <Shimmer className="h-4 w-3/4" />
              <Shimmer className="h-4 w-2/3" />
              <Shimmer className="h-5 w-1/2" />
            </div>
            <Shimmer className="h-12 w-full rounded-full" />
          </SkeletonCard>
        </div>
      </div>
    </ShimmerLoader>
  );
}

function SkeletonCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-borderDefault bg-bgWhite p-5">
      {children}
    </div>
  );
}
